import { createContext } from '@shared/utils/createContext';
import type { AccommodationsTourStepRegistration, AccommodationsTourStepType } from './AccommodationsTour.types';

export type AccommodationsTourStepContextValue = Readonly<{
  registerStep: (stepType: AccommodationsTourStepType, stepId: string, skipped?: boolean) => void;
  registeredSteps: Readonly<Record<string, ReadonlyArray<AccommodationsTourStepRegistration>>>;
  tourName: string;
}>;

export const [AccommodationsTourStepProvider, useAccommodationsTourStepContext] = createContext<AccommodationsTourStepContextValue>({
  name: 'AccommodationsTourContext',
  strict: false,
});
